// extracted by mini-css-extract-plugin
module.exports = {"primary":"#f98c3f","foreground":"#fff","background":"#222","beige":"#f7f6f1","loading":"#fdfcfb"};